export default {
  memoryState(state) {
    return state.memory;
  },
  memoryLoadingState(state) {
    return state.memoryLoading;
  },
  memorySubmitLoadingState(state) {
    return state.submitLoading;
  },
};
